const col = {
    name: {id: "name", label: "Nume", sortable: true, noWrap: true, width: "150px"},
    grade: {id: "grade", label: "An", sortable: true, width: "60px"},
    students_count: {id: "students_count", label: "Elevi", numeric: true, width: "60px"},
    teachers: {id: "teachers", label: "Profesori", noWrap: true, tooltip: true, tooltipTextLength: 50, width: "400px"},
    actions_medium: {id: "actions", label: "Acțiuni", numeric: true, sticky: true, width: "80px"},
}


export const CLASSROOMS_PRINCIPAL = [
    col.name, col.grade, col.students_count, col.teachers, col.actions_medium,
];

export const CLASSROOMS_TEACHER = [
    col.name, col.grade, col.students_count, col.teachers,
];

export const CLASSROOMS_TENANT_TEACHER = [
    col.name, col.grade, col.students_count, col.actions_medium,
];

export function getClassroomsTableColumns(
   position: string,
   tenantType: string
) {
    if(position === "principal") {
        return CLASSROOMS_PRINCIPAL;
    } else if(position === "teacher" && tenantType === "school") {
        return CLASSROOMS_TEACHER;
    } else {
        return CLASSROOMS_TENANT_TEACHER;
    }
}